import {Directive, Input} from '@angular/core';
import {Validator, NG_VALIDATORS, AbstractControl} from'@angular/forms';
import * as moment from 'moment/moment';

function getNumber(value: number | string) {
    if (typeof value === 'string')
        return parseFloat(value);
    else return value;
}

@Directive({
    selector: '[conditional-min-max]',
    providers: [{ provide: NG_VALIDATORS, useExisting: ConditionalMinMaxValidator, multi: true }]
})
export class ConditionalMinMaxValidator implements Validator {

    @Input('conditional-min-max') validationParams: {
        isRequired?: boolean;
        max?: number;
        min?: number;
    };

    private control: AbstractControl;

    ngOnChanges() {
        if (!!this.control) this.control.updateValueAndValidity();
    }

    validateMinMax(value: number): any {
        if (this.validationParams.min != null && value < this.validationParams.min) return {conditional : { minFail: true, limit: this.validationParams.min }};
        if (this.validationParams.max != null && value > this.validationParams.max) return {conditional: { maxFail: true, limit: this.validationParams.max }};
        return {};
    }

    validate(c: AbstractControl): { [key: string]: any } {
        this.control = c;
        const isRequired = this.validationParams.isRequired;
        const hasValue = !!c.value || c.value === 0;

        if (isRequired && !hasValue) return { conditional: { requiredFail: true }};
        if (!isRequired && !hasValue) return {};
        return this.validateMinMax(c.value);
    }
}

@Directive({
    selector: '[conditional-required]',
    providers: [{ provide: NG_VALIDATORS, useExisting: ConditionalRequiredValidator, multi: true }]
})
export class ConditionalRequiredValidator implements Validator {

    @Input('conditional-required') isRequired: boolean;

    private control: AbstractControl;

    ngOnChanges() {
        if (!!this.control) this.control.updateValueAndValidity();
    }

    validate(c: AbstractControl): { [key: string]: any } {
        this.control = c;
        if (!this.isRequired || (!!c.value || c.value === 0)) return {};
        return {conditional : { requiredFail: true }};
    }
}

@Directive({
    selector: '[min]:not([type=date]),[minExclusive]:not([type=date])',
    providers: [{ provide: NG_VALIDATORS, useExisting: MinValidatorDirective, multi: true }]
})
export class MinValidatorDirective implements Validator {

    @Input('min') minValue: number | string;
    @Input('minExclusive') exclusiveMinValue: number | string;
    validate(c: AbstractControl): { [key: string]: any } {
        if (this.minValue == null && this.exclusiveMinValue == null) return {};
        var isExclusive = this.exclusiveMinValue != null;
        var limit = getNumber(isExclusive?this.exclusiveMinValue:this.minValue);
        var value = getNumber(c.value);
        if (value < limit) return {
            'min': { limit, value }
        };
        if (value === limit && isExclusive) return {
            'minExclusive': { limit, value }
        };
        else return {};
    }
}






@Directive({
    selector: '[max]:not([type=date]),[maxExclusive]:not([type=date])',
    providers: [{ provide: NG_VALIDATORS, useExisting: MaxValidatorDirective, multi: true }]
})
export class MaxValidatorDirective implements Validator {

    @Input('max') maxValue: number | string;
    @Input('maxExclusive') exclusiveMaxValue: number | string;
    validate(c: AbstractControl): { [key: string]: any } {
        if (this.maxValue == null && this.exclusiveMaxValue == null) return {};
        var isExclusive = this.exclusiveMaxValue != null;
        var limit = getNumber(isExclusive ? this.exclusiveMaxValue : this.maxValue);
        var value = getNumber(c.value);
        if (value > limit) return {
            'max': { limit, value }
        };
        if (value === limit && isExclusive) return {
            'maxExclusive': { limit, value }
        };
        else return {};
    }
}




@Directive({ 
    selector: '[max][type=date],[maxExclusive][type=date]',
    providers: [{ provide: NG_VALIDATORS, useExisting: MaxDateValidatorDirective, multi: true }]
})
export class MaxDateValidatorDirective implements Validator {

    @Input('max') maxValue: Date | string;
    @Input('maxExclusive') exclusiveMaxValue: Date | string;
    validate(c: AbstractControl): { [key: string]: any } {
        if (this.maxValue == null && this.exclusiveMaxValue == null) return {};
        var isExclusive = this.exclusiveMaxValue != null;
        var limit = moment.utc(isExclusive ? this.exclusiveMaxValue:this.maxValue);
        var value = moment.utc(c.value);
        if (value.isAfter(limit)) return {
            'max': { limit, value }
        };
        if (value.isSame(limit) && isExclusive) return {
            'maxExclusive': { limit, value }
        };
        else return {};
    }
}


@Directive({
    selector: '[min][type=date],[minExclusive][type=date]',
    providers: [{ provide: NG_VALIDATORS, useExisting: MinDateValidatorDirective, multi: true }]
})
export class MinDateValidatorDirective implements Validator {

    @Input('min') minValue: Date | string;
    @Input('minExclusive') exclusiveMinValue: Date | string;
    validate(c: AbstractControl): { [key: string]: any } {
        if (this.minValue == null && this.exclusiveMinValue == null) return {};
        var isExclusive = this.exclusiveMinValue != null;
        var limit = moment.utc(isExclusive ? this.exclusiveMinValue : this.minValue);
        var value = moment.utc(c.value);
        if (value.isBefore( limit)) return {
            'min': { limit, value }
        };
        if (value.isSame(limit) && isExclusive) return {
            'minExclusive': { limit, value }
        };
        else return {};
    }
}

@Directive({
    selector: '[not-blank][required]',
    providers: [{ provide: NG_VALIDATORS, useExisting: NotBlankValidatorDirective, multi: true }]
})
export class NotBlankValidatorDirective implements Validator {

    validate(c: AbstractControl): { [key: string]: any } {
        if (c.value && typeof c.value === 'string')
        {
            if (!c.value.trim()) //all whitespace
            {
                return { 'not-blank': true };
            }
        }
        return {};
    }
}



export var VALIDATORS = [MaxValidatorDirective, MinValidatorDirective, NotBlankValidatorDirective, MinDateValidatorDirective, MaxDateValidatorDirective, ConditionalMinMaxValidator, ConditionalRequiredValidator, NotBlankValidatorDirective];


// WEBPACK FOOTER //
// F:/Agent/vsts-agent1/_work/76/s/CIA.ClientSide/~/@wtw/toolkit/src/validation/validators.ts